module.exports = "/images/cart-w.svg?b133b2c7aaefca21db362cb6b69592a5";